import { sortDefined } from './sort-defined.function';
import { SortDirection } from './sort-direction.type';

export function sortString(
  a: string | undefined,
  b: string | undefined,
  direction: SortDirection = 'asc',
): number {
  const sortDefinedResult: number = sortDefined(a, b, direction);
  if (sortDefinedResult !== 0) {
    return sortDefinedResult;
  }

  // Explicitly handle undefined to always place it last.
  if (a === undefined) {
    return 1;
  }

  if (b === undefined) {
    return -1;
  }

  // Fallback to localeCompare for string comparison
  //eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const result = (a ?? '').localeCompare(b ?? '');
  return direction === 'asc' ? result : -result;
}
